/**
 * Müşterinin hukuki kimliği.
 * JewApi.Data.Domain/Enums/DbEnums.cs — CustomerType
 *
 * e-Belge taraf bilgisi buna göre kurulur: gerçek kişide ad/soyad + TCKN,
 * tüzel kişide ünvan + VKN gönderilir.
 */
export enum CustomerType {
  Person = 1,
  Company = 2,
}

export const CUSTOMER_TYPE_OPTIONS = [
  { value: CustomerType.Person, label: 'Gerçek Kişi' },
  { value: CustomerType.Company, label: 'Tüzel Kişi' },
];
